export default __webpack_public_path__ + "static/NotoSansThai-Regular-5d628015e61b17a93aecbc82da022780.ttf";